// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BSG-compliant styles while maintaining original design */
* {
  box-sizing: border-box;
}

/* Skip link for keyboard navigation */
.bsg-skip-link {
  position: absolute;
  top: -9999px;
  left: -9999px;
  background: white;
  color: var(--ion-color-secondary);
  padding: 15px;
  z-index: 10000;
  font-weight: bold;
  border: 2px solid var(--ion-color-secondary);
}
.bsg-skip-link:focus {
  top: 0;
  left: 0;
}

ion-content {
  background: url('home_background.png') no-repeat center center/105% 105%;
  position: relative;
  /* Add keyboard focus styles */
}
ion-content.bsg-keyboard-mode *:focus {
  outline: 2px solid var(--ion-color-primary) !important;
  outline-offset: 2px !important;
  box-shadow: 0 0 0 4px rgba(126, 167, 105, 0.25) !important;
}
ion-content .order-types {
  width: 70%;
  margin: 0 auto;
}
@media (max-width: 992px) {
  ion-content .order-types {
    width: 100%;
    padding: 10px;
  }
}
ion-content .order-types .padding-block {
  height: 30vh;
}
@media (max-width: 992px) {
  ion-content .order-types .padding-block {
    height: 30px;
  }
}
ion-content .order-types .info_block {
  width: -moz-fit-content;
  width: fit-content;
  padding: 20px;
  background: white;
  box-shadow: 0px 4px 15px 0px rgba(79, 97, 79, 0.1490196078);
  border-radius: 16px;
  /* Make sure keyboard focus is visible */
}
@media (max-width: 992px) {
  ion-content .order-types .info_block {
    width: 100%;
  }
}
ion-content .order-types .info_block:focus-within {
  box-shadow: 0px 4px 15px 0px rgba(79, 97, 79, 0.3764705882);
}
ion-content .order-types h4 {
  font-size: 24px;
  color: var(--ion-color-secondary);
  text-align: center;
  text-transform: uppercase;
  margin-top: 15px;
}
ion-content .order-types .order-types-blocks {
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-direction: column;
}
ion-content .order-types .order-types-blocks .order-type-item {
  width: 100% !important;
  border-radius: 10px;
  box-shadow: 0px 4px 15px 0px rgba(79, 97, 79, 0.1490196078);
  overflow: hidden;
  margin: 10px 0px;
  padding: 15px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border: 1px solid transparent;
  transition: border 0.3s ease-in-out;
  cursor: pointer;
  /* Keyboard accessibility enhancements */
  /* Selected state */
}
ion-content .order-types .order-types-blocks .order-type-item:focus {
  border: 1px solid var(--ion-color-primary);
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
  box-shadow: 0 0 0 4px rgba(126, 167, 105, 0.25);
}
ion-content .order-types .order-types-blocks .order-type-item:focus p {
  animation: moveAndShow 0.5s ease-in-out forwards;
  opacity: 1;
}
ion-content .order-types .order-types-blocks .order-type-item:focus ion-icon {
  animation: moveIcon 0.5s ease-in-out forwards;
}
ion-content .order-types .order-types-blocks .order-type-item:hover {
  border: 1px solid #7EA769;
}
ion-content .order-types .order-types-blocks .order-type-item:hover p {
  animation: moveAndShow 0.5s ease-in-out forwards;
  opacity: 1;
}
ion-content .order-types .order-types-blocks .order-type-item:hover ion-icon {
  animation: moveIcon 0.5s ease-in-out forwards;
}
ion-content .order-types .order-types-blocks .order-type-item.selected {
  border: 1px solid #7EA769;
  background-color: rgba(126, 167, 105, 0.1);
}
ion-content .order-types .order-types-blocks .order-type-item.selected::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: var(--ion-color-primary);
}
ion-content .order-types .order-types-blocks .order-type-item .logo-block {
  width: 62px;
  height: 62px;
  background: var(--ion-color-primary);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
ion-content .order-types .order-types-blocks .order-type-item .logo-block ion-icon {
  fill: white;
  width: -webkit-fill-available;
  width: 35px;
  height: 35px;
  position: absolute;
}
ion-content .order-types .order-types-blocks .order-type-item .text-block {
  width: calc(100% - 62px);
  padding: 0px 20px;
}
ion-content .order-types .order-types-blocks .order-type-item .text-block h3 {
  font-size: 16px;
  font-family: AppFontBold, sans-serif;
  color: var(--ion-color-secondary);
  margin-bottom: 15px;
}
ion-content .order-types .order-types-blocks .order-type-item .text-block p {
  width: 100%;
  font-size: 12px;
  color: var(--ion-color-secondary);
  opacity: 0;
}
@media (max-width: 992px) {
  ion-content .order-types .order-types-blocks .order-type-item .text-block p {
    opacity: 1;
  }
}

@keyframes moveIcon {
  0% {
    top: -10px;
  }
  50% {
    top: 10px;
  }
  75% {
    top: -10px;
  }
  100% {
    top: 50%;
    transform: translateY(-50%);
  }
}
@keyframes moveAndShow {
  0% {
    opacity: 0;
    transform: translateX(100%);
  }
  100% {
    opacity: 1;
    transform: translateX(0%);
  }
}
.orders-block {
  width: 100%;
  background: white;
  margin-top: 50px;
  padding: 20px;
}
.orders-block h4 {
  font-size: 22px;
  color: var(--ion-color-secondary);
  text-transform: uppercase;
}
.orders-block .width-wrapper {
  width: 70%;
  margin: 0 auto;
}
@media (max-width: 992px) {
  .orders-block .width-wrapper {
    width: 100%;
  }
}
.orders-block .wrapper-for-orders {
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding: 10px 0px 15px 10px;
  /* Keyboard navigation support for horizontal scrolling */
}
@media (max-width: 992px) {
  .orders-block .wrapper-for-orders {
    flex-wrap: wrap;
  }
}
.orders-block .wrapper-for-orders:focus-within {
  outline: 2px solid var(--ion-color-primary);
  border-radius: 4px;
}
.orders-block .wrapper-for-orders app-my-order {
  min-width: 33%;
  height: 100%;
  margin-right: 10px;
  /* Make focusable */
}
@media (max-width: 992px) {
  .orders-block .wrapper-for-orders app-my-order {
    min-width: 100%;
  }
}
.orders-block .wrapper-for-orders app-my-order:focus {
  outline: 2px solid var(--ion-color-primary);
  box-shadow: 0 0 0 4px rgba(126, 167, 105, 0.25);
  border-radius: 4px;
}

.news-section {
  padding: 20px 0px 40px 20px;
  display: flex;
  overflow-y: auto;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  /* Keyboard navigation for horizontal scrolling */
}
.news-section:focus-within {
  outline: 2px solid var(--ion-color-primary);
  border-radius: 4px;
}
.news-section app-draw-news-braze-item {
  min-width: 90%;
  /* Make focusable */
}
@media (min-width: 991px) {
  .news-section app-draw-news-braze-item {
    min-width: 35%;
    max-width: 35%;
  }
}
.news-section app-draw-news-braze-item:focus {
  outline: 2px solid var(--ion-color-primary);
  box-shadow: 0 0 0 4px rgba(126, 167, 105, 0.25);
  border-radius: 4px;
}
.news-section h3 {
  text-align: left;
  font-family: AppFontBold, sans-serif;
  color: var(--ion-color-secondary);
  text-align: left;
  width: 100%;
  font-size: 20px;
  padding-left: 20px;
  text-transform: uppercase;
}

/* High contrast mode enhancements */
.bsg-high-contrast .order-types .info_block {
  background: #000000;
  border: 2px solid #ffffff;
}
.bsg-high-contrast .order-type-item {
  background: #000000;
  border: 2px solid #ffffff !important;
}
.bsg-high-contrast .order-type-item.selected {
  border-left: 4px solid #ffff00 !important;
}
.bsg-high-contrast .order-type-item:focus {
  outline: 3px dashed #ffff00 !important;
}
.bsg-high-contrast .order-type-item .logo-block {
  background: #ffff00 !important;
}
.bsg-high-contrast .order-type-item .logo-block ion-icon {
  fill: #000000 !important;
}
.bsg-high-contrast .order-type-item .text-block h3, .bsg-high-contrast .order-type-item .text-block p {
  color: #ffffff !important;
}
.bsg-high-contrast .order-type-item .text-block p {
  opacity: 1 !important;
}
.bsg-high-contrast .orders-block {
  background: #000000;
  border-top: 2px solid #ffffff;
}
.bsg-high-contrast .orders-block h4 {
  color: #ffff00 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/home/home.page.dean_and_david.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA,2DAAA;AACA;EACE,sBAAA;AADF;;AAIA,sCAAA;AACA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,iCAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;EACA,4CAAA;AADF;AAGE;EACE,MAAA;EACA,OAAA;AADJ;;AAKA;EACE,wEAAA;EACA,kBAAA;EAEA,8BAAA;AAHF;AAIE;EACE,sDAAA;EACA,8BAAA;EACA,0DAAA;AAFJ;AAKE;EACE,UAAA;EACA,cAAA;AAHJ;AC5BE;ED6BA;IAII,WAAA;IACA,aAAA;EADJ;AACF;AAGI;EACE,YAAA;AADN;ACrCE;EDqCE;IAGI,YAAA;EACN;AACF;AAEI;EACE,uBAAA;EAAA,kBAAA;EAIA,aAAA;EACA,iBAAA;EACA,2DAAA;EACA,mBAAA;EAEA,wCAAA;AAJN;AClDE;ED4CE;IAGI,WAAA;EAON;AACF;AAAM;EACE,2DAAA;AAER;AAEI;EACE,eAAA;EACA,iCAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AAAN;AAGI;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,sBAAA;AADN;AAGM;EACE,sBAAA;EACA,mBAAA;EACA,2DAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,6BAAA;EACA,mCAAA;EACA,eAAA;EAEA,wCAAA;EA4BA,mBAAA;AA7BR;AAEQ;EACE,0CAAA;EACA,2CAAA;EACA,mBAAA;EACA,+CAAA;AAAV;AAEU;EACE,gDAAA;EACA,UAAA;AAAZ;AAGU;EACE,6CAAA;AADZ;AAKQ;EACE,yBAAA;AAHV;AAIU;EACE,gDAAA;EACA,UAAA;AAFZ;AAIU;EACE,6CAAA;AAFZ;AAOQ;EACE,yBAAA;EACA,0CAAA;AALV;AAOU;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,0CAAA;AALZ;AASQ;EACE,WAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAPV;AASU;EACE,WAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAPZ;AAWQ;EACE,wBAAA;EACA,iBAAA;AATV;AAWU;EACE,eAAA;EACA,oCAAA;EACA,iCAAA;EACA,mBAAA;AATZ;AAYU;EACE,WAAA;EACA,eAAA;EACA,iCAAA;EACA,UAAA;AAVZ;AC5JE;EDkKQ;IAMI,UAAA;EARZ;AACF;;AAgBA;EACE;IACE,UAAA;EAbF;EAeA;IACE,SAAA;EAbF;EAeA;IACE,UAAA;EAbF;EAeA;IACE,QAAA;IACA,2BAAA;EAbF;AACF;AAgBA;EACE;IACE,UAAA;IACA,2BAAA;EAdF;EAgBA;IACE,UAAA;IACA,yBAAA;EAdF;AACF;AAiBA;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;AAfF;AAiBE;EACE,eAAA;EACA,iCAAA;EACA,yBAAA;AAfJ;AAkBE;EACE,UAAA;EACA,cAAA;AAhBJ;AC1ME;EDwNA;IAII,WAAA;EAdJ;AACF;AAiBE;EACE,aAAA;EACA,2BAAA;EACA,iBAAA;EACA,gBAAA;EACA,2BAAA;EAKA,yDAAA;AAnBJ;ACvNE;EDgOA;IAOI,eAAA;EAZJ;AACF;AAeI;EACE,2CAAA;EACA,kBAAA;AAbN;AAgBI;EACE,cAAA;EAIA,YAAA;EACA,kBAAA;EAEA,mBAAA;AAlBN;ACtOE;EDgPE;IAGI,eAAA;EATN;AACF;AAcM;EACE,2CAAA;EACA,+CAAA;EACA,kBAAA;AAZR;;AAkBA;EACE,2BAAA;EACA,aAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,iBAAA;EAEA,iDAAA;AAhBF;AAiBE;EACE,2CAAA;EACA,kBAAA;AAfJ;AAkBE;EAKE,cAAA;EAEA,mBAAA;AArBJ;ACxQE;EDsRA;IAEI,cAAA;IACA,cAAA;EAZJ;AACF;AAgBI;EACE,2CAAA;EACA,+CAAA;EACA,kBAAA;AAdN;AAkBE;EACE,gBAAA;EACA,oCAAA;EACA,iCAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AAhBJ;;AAoBA,oCAAA;AAEE;EACE,mBAAA;EACA,yBAAA;AAlBJ;AAqBE;EACE,mBAAA;EACA,oCAAA;AAnBJ;AAqBI;EACE,yCAAA;AAnBN;AAsBI;EACE,sCAAA;AApBN;AAuBI;EACE,8BAAA;AArBN;AAuBM;EACE,wBAAA;AArBR;AA0BM;EACE,yBAAA;AAxBR;AA2BM;EACE,qBAAA;AAzBR;AA8BE;EACE,mBAAA;EACA,6BAAA;AA5BJ;AA8BI;EACE,yBAAA;AA5BN","sourcesContent":["@import '../../../theme/mixins';\n\n/* BSG-compliant styles while maintaining original design */\n* {\n  box-sizing: border-box;\n}\n\n/* Skip link for keyboard navigation */\n.bsg-skip-link {\n  position: absolute;\n  top: -9999px;\n  left: -9999px;\n  background: white;\n  color: var(--ion-color-secondary);\n  padding: 15px;\n  z-index: 10000;\n  font-weight: bold;\n  border: 2px solid var(--ion-color-secondary);\n  \n  &:focus {\n    top: 0;\n    left: 0;\n  }\n}\n\nion-content {\n  background: url('../../../assets/dean_and_david/home_background.png') no-repeat center center / 105% 105%;\n  position: relative;\n  \n  /* Add keyboard focus styles */\n  &.bsg-keyboard-mode *:focus {\n    outline: 2px solid var(--ion-color-primary) !important;\n    outline-offset: 2px !important;\n    box-shadow: 0 0 0 4px rgba(126, 167, 105, 0.25) !important;\n  }\n  \n  .order-types {\n    width: 70%;\n    margin: 0 auto;\n    @include mobile {\n      width: 100%;\n      padding: 10px;\n    }\n    \n    .padding-block {\n      height: 30vh;\n      @include mobile {\n        height: 30px;\n      }\n    }\n    \n    .info_block {\n      width: fit-content;\n      @include mobile {\n        width: 100%;\n      }\n      padding: 20px;\n      background: white;\n      box-shadow: 0px 4px 15px 0px #4F614F26;\n      border-radius: 16px;\n      \n      /* Make sure keyboard focus is visible */\n      &:focus-within {\n        box-shadow: 0px 4px 15px 0px #4F614F60;\n      }\n    }\n    \n    h4 {\n      font-size: 24px;\n      color: var(--ion-color-secondary);\n      text-align: center;\n      text-transform: uppercase;\n      margin-top: 15px;\n    }\n    \n    .order-types-blocks {\n      display: flex;\n      justify-content: space-between;\n      width: 100%;\n      flex-direction: column;\n      \n      .order-type-item {\n        width: 100% !important;\n        border-radius: 10px;\n        box-shadow: 0px 4px 15px 0px #4F614F26;\n        overflow: hidden;\n        margin: 10px 0px;\n        padding: 15px;\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n        border: 1px solid transparent;\n        transition: border 0.3s ease-in-out;\n        cursor: pointer;\n        \n        /* Keyboard accessibility enhancements */\n        &:focus {\n          border: 1px solid var(--ion-color-primary);\n          outline: 2px solid var(--ion-color-primary);\n          outline-offset: 2px;\n          box-shadow: 0 0 0 4px rgba(126, 167, 105, 0.25);\n          \n          p {\n            animation: moveAndShow 0.5s ease-in-out forwards;\n            opacity: 1;\n          }\n          \n          ion-icon {\n            animation: moveIcon 0.5s ease-in-out forwards;\n          }\n        }\n        \n        &:hover {\n          border: 1px solid #7EA769;\n          p {\n            animation: moveAndShow 0.5s ease-in-out forwards;\n            opacity: 1;\n          }\n          ion-icon {\n            animation: moveIcon 0.5s ease-in-out forwards;\n          }\n        }\n        \n        /* Selected state */\n        &.selected {\n          border: 1px solid #7EA769;\n          background-color: rgba(126, 167, 105, 0.1);\n          \n          &::before {\n            content: \"\";\n            position: absolute;\n            left: 0;\n            top: 0;\n            bottom: 0;\n            width: 4px;\n            background-color: var(--ion-color-primary);\n          }\n        }\n        \n        .logo-block {\n          width: 62px;\n          height: 62px;\n          background: var(--ion-color-primary);\n          border-radius: 50%;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          position: relative;\n          \n          ion-icon {\n            fill: white;\n            width: -webkit-fill-available;\n            width: 35px;\n            height: 35px;\n            position: absolute;\n          }\n        }\n        \n        .text-block {\n          width: calc(100% - 62px);\n          padding: 0px 20px;\n          \n          h3 {\n            font-size: 16px;\n            font-family: AppFontBold, sans-serif;\n            color: var(--ion-color-secondary);\n            margin-bottom: 15px;\n          }\n          \n          p {\n            width: 100%;\n            font-size: 12px;\n            color: var(--ion-color-secondary);\n            opacity: 0;\n            @include mobile {\n              opacity: 1;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@keyframes moveIcon {\n  0% {\n    top: -10px;\n  }\n  50% {\n    top: 10px;\n  }\n  75% {\n    top: -10px;\n  }\n  100% {\n    top: 50%;\n    transform: translateY(-50%);\n  }\n}\n\n@keyframes moveAndShow {\n  0% {\n    opacity: 0;\n    transform: translateX(100%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0%);\n  }\n}\n\n.orders-block {\n  width: 100%;\n  background: white;\n  margin-top: 50px;\n  padding: 20px;\n  \n  h4 {\n    font-size: 22px;\n    color: var(--ion-color-secondary);\n    text-transform: uppercase;\n  }\n  \n  .width-wrapper {\n    width: 70%;\n    margin: 0 auto;\n    @include mobile {\n      width: 100%;\n    }\n  }\n  \n  .wrapper-for-orders {\n    display: flex;\n    justify-content: flex-start;\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    padding: 10px 0px 15px 10px;\n    @include mobile {\n      flex-wrap: wrap;\n    }\n    \n    /* Keyboard navigation support for horizontal scrolling */\n    &:focus-within {\n      outline: 2px solid var(--ion-color-primary);\n      border-radius: 4px;\n    }\n    \n    app-my-order {\n      min-width: 33%;\n      @include mobile {\n        min-width: 100%\n      }\n      height: 100%;\n      margin-right: 10px;\n      \n      /* Make focusable */\n      &:focus {\n        outline: 2px solid var(--ion-color-primary);\n        box-shadow: 0 0 0 4px rgba(126, 167, 105, 0.25);\n        border-radius: 4px;\n      }\n    }\n  }\n}\n\n.news-section {\n  padding: 20px 0px 40px 20px;\n  display: flex;\n  overflow-y: auto;\n  justify-content: flex-start;\n  align-items: center;\n  flex-wrap: nowrap;\n  \n  /* Keyboard navigation for horizontal scrolling */\n  &:focus-within {\n    outline: 2px solid var(--ion-color-primary);\n    border-radius: 4px;\n  }\n  \n  app-draw-news-braze-item {\n    @include desktop {\n      min-width: 35%;\n      max-width: 35%;\n    }\n    min-width: 90%;\n    \n    /* Make focusable */\n    &:focus {\n      outline: 2px solid var(--ion-color-primary);\n      box-shadow: 0 0 0 4px rgba(126, 167, 105, 0.25);\n      border-radius: 4px;\n    }\n  }\n  \n  h3 {\n    text-align: left;\n    font-family: AppFontBold, sans-serif;\n    color: var(--ion-color-secondary);\n    text-align: left;\n    width: 100%;\n    font-size: 20px;\n    padding-left: 20px;\n    text-transform: uppercase;\n  }\n}\n\n/* High contrast mode enhancements */\n.bsg-high-contrast {\n  .order-types .info_block {\n    background: #000000;\n    border: 2px solid #ffffff;\n  }\n  \n  .order-type-item {\n    background: #000000;\n    border: 2px solid #ffffff !important;\n    \n    &.selected {\n      border-left: 4px solid #ffff00 !important;\n    }\n    \n    &:focus {\n      outline: 3px dashed #ffff00 !important;\n    }\n    \n    .logo-block {\n      background: #ffff00 !important;\n      \n      ion-icon {\n        fill: #000000 !important;\n      }\n    }\n    \n    .text-block {\n      h3, p {\n        color: #ffffff !important;\n      }\n      \n      p {\n        opacity: 1 !important;\n      }\n    }\n  }\n  \n  .orders-block {\n    background: #000000;\n    border-top: 2px solid #ffffff;\n    \n    h4 {\n      color: #ffff00 !important;\n    }\n  }\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
